import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {constants} from 'cng-web-lib'
import EhblHouseBillKeys from 'src/constants/locale/key/EhblHouseBill'


const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  const errMsgAlphaNumericWithSpecialChar = translate(
    Namespace.EHBL_HOUSE_BILL,
    EhblHouseBillKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC_WITH_SPECIAL_CHAR
  )

  const errMsgMaxLength = translate(
    Namespace.EHBL_HOUSE_BILL,
    EhblHouseBillKeys.ValidationMessage.ERROR_MSG_MAX_LENGTH
  )

  const errMsgAlphaNumeric = translate(
    Namespace.EHBL_HOUSE_BILL,
    EhblHouseBillKeys.ValidationMessage.ERROR_MSG_ALPHA_NUMERIC
  )

  const regexAlphaNumeric = '^[a-zA-Z0-9 ]*$'
  const regexAlphaNumericWithSpecialChar = '^[a-zA-Z0-9 ,+\\-$#@%&()!\'`^_:;.?\\[\\]\\{\\}\\/="\\|\\\\ ]+$'

  return Yup.object({
    name: Yup.string().nullable().required(requiredMessage).matches(regexAlphaNumericWithSpecialChar,errMsgAlphaNumericWithSpecialChar).max(50, errMsgMaxLength+" 50"),
    statusNotificationType: Yup.string().nullable().required(requiredMessage),
    email: Yup.string().email().trim().required(requiredMessage).matches(regexAlphaNumericWithSpecialChar,errMsgAlphaNumericWithSpecialChar).max(50, errMsgMaxLength+" 50").nullable(),
    phoneNumber: Yup.string().trim().nullable().matches(regexAlphaNumericWithSpecialChar,errMsgAlphaNumericWithSpecialChar).max(15,  errMsgMaxLength+" 15"),
  }) 
}

export default makeValidationSchema
